/**
 * @deprecated use ServerZoneType instead
 */
export var ServerZone;
(function (ServerZone) {
  ServerZone["US"] = "US";
  ServerZone["EU"] = "EU";
})(ServerZone || (ServerZone = {}));
